<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="sm" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :visible="modal.show"
                   :title="title" :ok-title="$t('Submit')" modal-class="mobile-full-screen"
                   scrollable>
      <div class="row">
        <div class="col-md-12">
          <language-code-select-input-widget :model="model" attribute="language"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import InventoryOverviewGenerationModel
    from "@/modules/inventory/inventory-overview-generation-modal/InventoryOverviewGeneration.model";
  import LanguageCodeSelectInputWidget from "@/core/widgets/LanguageCodeSelectInputWidget";
  import InventoryService from "@/modules/inventory/InventoryService";

  const {mapActions, mapState} = createNamespacedHelpers('inventory');

  export default {
    name: "InventoryOverviewGenerationModal",
    components: {
      LanguageCodeSelectInputWidget,
      ArtisioModal,
    },
    data() {
      return {
        model: new InventoryOverviewGenerationModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.inventoryOverviewGenerationModal,
        currentPayload: state => state.inventoryOverviewGenerationModal.payload,
      }),
      title() {
        return this.$i18n.t("Inventory Overview Export")
      }
    },
    methods: {
      ...mapActions(["hideInventoryOverviewGenerationModal"]),
      onHidden() {
        this.model = new InventoryOverviewGenerationModel();
        this.hideInventoryOverviewGenerationModal()
      },
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t("Are you sure you want to export inventory overview with following filters?"))
        if (!success) {
          return;
        }

        let response = await InventoryService.exportInventoryOverview({
          ...this.currentPayload, language: this.model.language
        })
        if (response.success) {
          this.$toast('success', this.$i18n.t("Inventory overview export has successfully started."))
          this.hideInventoryOverviewGenerationModal()
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else {
            this.$errorDialog(this.$i18n.t("Something went wrong. Please, try again later"))
          }
        }
      }
    }
  }
</script>

<style scoped>
</style>
